import React, { Component } from 'react';
import { connect } from "react-redux";
import BookMarker from '../Map/bmarker';
import Directions from '../Map/directions';
import EstimatePrice from "./estimateprice"
import { estimatePrice } from '../../actions';
import Map from "../Map/map";

class BookingMap extends Component {
    
    handleMapMounted = (map) => {
        this._map = map;
    }

    componentDidUpdate(prevProps){
        let { pickupChanged, dropChanged, pickup, drop } = this.props.marker;
        if(pickupChanged && pickup !== prevProps.marker.pickup){
            this._map.panTo(pickup);
            this.estimateprice(pickup, drop);
        }
        if(dropChanged && drop !== prevProps.marker.drop){
            this._map.panTo(drop);
            this.estimateprice(pickup, drop);
        }
    }

    estimateprice(pickup, drop){
        if(pickup && drop){
            let data = {
                "pickup_latitude": pickup.lat.toFixed(5),
                "pickup_longitude": pickup.lng.toFixed(5),
                "delivery_latitude": drop.lat.toFixed(5),
                "delivery_longitude": drop.lng.toFixed(5)
            };
            this.props.dispatch(estimatePrice(data));
        }
    }

    render() { 
        let { pickup , drop } = this.props.marker;
        return (
            <Map
                onMapMounted={this.handleMapMounted}
            > 
                <BookMarker type="P" />
                <BookMarker type="D" />
                {pickup && drop && 
                    <Directions P={pickup} D={drop} />
                }
                <EstimatePrice />
            </Map> 
        );
    }

}

const mapStateToProps = (state) => ({
    marker: state.bookingLoc
})

export default connect(mapStateToProps)(BookingMap);